module.exports = __webpack_public_path__ + "img/scroll-arrow-left.19da82db.svg";